module.exports = __webpack_public_path__ + "img/logo-dark.3bfdc7dd.png";